import { ETabsVariant, Tabs } from '@/components/common/Hero/Tabs';
import { OptimizelyFlags, useExperimentIsEnabled } from '@/services/experiments';

export const HeroTabs = () => {
  const isEscapesPillsEnabled = useExperimentIsEnabled(OptimizelyFlags.ESCAPES_PILL, {
    enabledVariationKey: 'on',
  });

  if (!isEscapesPillsEnabled) {
    return <div className="pt-10 lg:pt-18" />;
  }

  return (
    <div className="pt-3 pb-5 lg:py-3">
      <Tabs tabVariant={ETabsVariant.Rentals} />
    </div>
  );
};
